import { Colors } from '../theme/colors';


const isGoogleMapsLoaded = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    window.google?.maps &&
    window.google.maps.Size &&
    window.google.maps.Point
  );
};


export const createMarkerIcon = (color: string, size: number = 40): google.maps.Icon | undefined => {
  if (!isGoogleMapsLoaded()) {
    return undefined;
  }

  const maps = window.google.maps;


  const svg = `
    <svg width="${size}" height="${size}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="${color}" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
      <circle cx="12" cy="9" r="3" fill="white"/>
    </svg>
  `;

  try {
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
      scaledSize: new maps.Size(size, size),
      anchor: new maps.Point(size / 2, size),
      origin: new maps.Point(0, 0),
    };
  } catch (error) {
    console.warn('Failed to create marker icon:', error);
    return undefined;
  }
};


export const createDriverMarkerIcon = (): google.maps.Icon | undefined => {
  return createMarkerIcon(Colors.primary, 50);
};


export const createPickupMarkerIcon = (): google.maps.Icon | undefined => {
  return createMarkerIcon(Colors.success, 45);
};


export const createDestinationMarkerIcon = (): google.maps.Icon | undefined => {
  return createMarkerIcon(Colors.error, 45);
};


export const createRiderMarkerIcon = (): google.maps.Icon | undefined => {
  return createMarkerIcon(Colors.info, 40);
};

